<template>
    <IPNav :ipNavService="ipNavService" :navModuleType="NAV_MENU_TYPE.NEW_TASKS" />
</template>

<script setup lang="ts">
import { IPNav, NAV_MENU_TYPE } from '@patsnap-biz/ip-nav';
import { useIpNavService } from './composables/use-ip-nav-service';
import '@patsnap-biz/nav-user-avatar/lib/style';
import '@patsnap-biz/ip-nav/lib/style';

const { ipNavService } = useIpNavService();

</script>

